export default "__VITE_ASSET__cbd97950__"